<template>
  <ListingBlock
    v-if="view.hasDocs()"
    class="multi-block"
    :view="view"
    :docs="view.docs().filteredDocs.slice(0, 4)"
    :cardProps="{ showFreeBooks }"
    :docViewEventProperties="docViewEventProperties"
  >
    <template v-if="customList" #headerActions>
      <div class="multi-block__menu-outline">
        <CustomListMenu
          v-if="!customList.is_standard"
          :list="customList"
          :listsView="customListsView"
          position="right"
        />
      </div>
    </template>
  </ListingBlock>
  <EmptyListingBlock v-else class="multi-block" :title="view.pageTitle()">
    <template v-if="customList" #headerActions>
      <div class="multi-block__menu-outline">
        <CustomListMenu
          v-if="!customList.is_standard"
          :list="customList"
          :listsView="customListsView"
          position="right"
        />
      </div>
    </template>
    <p>
      Documents you add to this list will appear here. To add a book, article,
      or podcast episode, click on the
      <span class="iconfont iflag2"></span> icon on the card, then on "Add to
      List" and select the list.
    </p>
  </EmptyListingBlock>
</template>

<script setup lang="ts">
import ListingBlock from '@/app/components/listing/ListingBlock.vue'
import CustomListMenu from '@/app/components/custom.lists/CustomListMenu.vue'
import EmptyListingBlock from '@/app/components/listing/EmptyListingBlock.vue'

import type { ListView } from '@/models/docs.list'
import type { CustomList, ListItem } from '@/models/interfaces'
import { CustomListsView } from '@/models/custom.lists'

withDefaults(
  defineProps<{
    view: ListView
    docViewEventProperties?: (doc: ListItem) => Record<string, unknown>
    customList?: CustomList
    customListsView?: CustomListsView
    /**
     * Show the "Free" badge on free books.
     */
    showFreeBooks?: boolean
  }>(),
  {},
)
</script>

<style lang="scss" scoped>
.multi-block {
  --listing-block-number-of-columns: 4;
  --listing-block-items-width-mobile: 220px;
  &__menu-outline {
    border: 1px solid $c-black-6;
    border-radius: 20px;
    padding: 4px;
    transition: border-color 0.3s ease-in-out;
    @include hover {
      border-color: $c-black-2;
    }
  }
}

.night-mode .multi-block {
  &__menu-outline {
    border-color: $c-dark-8;
    @include hover {
      border-color: $c-black-11;
    }
  }
}

:deep(.custom-list-menu .action-menu__button) {
  color: $c-black-6;
  @include hover {
    color: $c-black-2;
    background: transparent;
  }
}
</style>
